import CreateUpdateMinigridFormPresenter from "../../CreateMinigrid/CreateUpdateMinigridForm/CreateUpdateMinigridFormPresenter";

export default function UpdateMinigridForm() {
  return (
    <CreateUpdateMinigridFormPresenter isUpdate />
  )
}
